import { QRCodeCanvas } from "qrcode.react";
import { Bell, BookOpen, Calculator, Printer, Stethoscope } from "lucide-react";
import { LOGO } from "@/lib/api";

const URL_APP = `${window.location.origin}/?instalar=1`;
const PERKS = [
  [BookOpen, "Guía de salud del caballo"],
  [Calculator, "Calculadora de dieta y peso"],
  [Stethoscope, "Diagnóstico y asesor experto"],
  [Bell, "Avisos de vacunas y herrado"],
];

export default function AppPoster() {
  return (
    <div className="bg-slate-100 print:bg-white py-10 print:py-0 px-4" data-testid="app-poster-page">
      <div className="max-w-[210mm] mx-auto mb-6 flex flex-wrap items-center justify-between gap-3 no-print">
        <p className="text-slate-600">Cartel A4 para imprimir o guardar en PDF. El código abre faunny-ia.com y propone instalar la app.</p>
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 bg-[#B23A38] hover:bg-[#962F2D] text-white font-bold px-6 py-3 rounded-full transition-colors" data-testid="poster-print-button"><Printer size={18} />Imprimir o guardar PDF</button>
      </div>
      <div className="poster-sheet bg-white mx-auto w-full max-w-[210mm] sm:aspect-[210/297] print:aspect-[210/297] shadow-xl print:shadow-none flex flex-col overflow-hidden" data-testid="app-poster">
        <div className="h-3 bg-[#B23A38]" />
        <div className="flex-1 flex flex-col items-center text-center px-[8%] pt-[6%]">
          <img src={LOGO} alt="Faunny" className="w-[34%]" />
          <h1 className="mt-[4%] font-display font-black uppercase text-[#0B1D3A] leading-none text-[clamp(28px,6.5vw,58px)]">Lleva Faunny<br /><span className="text-[#B23A38]">siempre contigo</span></h1>
          <p className="mt-3 text-[clamp(15px,2.4vw,22px)] text-slate-700">Escanea con la cámara del móvil e <b className="text-[#3D88B8]">instala la app gratis</b></p>
          <div className="mt-[5%] p-4 rounded-3xl border-[6px] border-[#3D88B8]">
            <QRCodeCanvas value={URL_APP} size={640} level="M" marginSize={1} fgColor="#0B1D3A" style={{ width: "min(52vw, 300px)", height: "auto" }} data-testid="poster-qr" />
          </div>
          <ul className="mt-[5%] grid grid-cols-2 gap-x-8 gap-y-3 text-left text-[clamp(13px,2vw,18px)] text-[#0B1D3A]">
            {PERKS.map(([Icon, t]) => <li key={t} className="flex items-center gap-2"><Icon size={22} className="text-[#3D88B8] shrink-0" />{t}</li>)}
          </ul>
        </div>
        <div className="bg-[#3D88B8] text-white text-center py-4 font-bold tracking-wide text-[clamp(14px,2.2vw,20px)]">faunny-ia.com · Complementos, salud e higiene para caballos</div>
      </div>
    </div>
  );
}
